export default __webpack_public_path__ + "static/media/headphone.6ba6d0f2.jpg";